export default __webpack_public_path__ + "static/poster-00c180f5cffece7e1160046dcad512da.png";